import React from 'react';
import proptypes from 'prop-types';
import { Text } from './Text';

const { string, bool } = proptypes;

const getTextMaxWidth = ({ ranges, sideBySide, stacked }) => {
  if (ranges) {
    return 'sui-max-w-[45%]';
  }
  if (sideBySide) {
    return 'sui-max-w-[55%]';
  }
  if (stacked) {
    return 'sui-max-w-[30%]';
  }
  return '';
};

const ImageCaption = ({ subHeader, subSubHeader, className }) => {
  if (!subHeader) {
    return null;
  }
  return (
    <div className={className}>
      <Text text={subHeader} />
      {subSubHeader && <Text text={subSubHeader} />}
    </div>
  );
};

ImageCaption.propTypes = {
  subHeader: string,
  subSubHeader: string,
  className: string.isRequired
};

ImageCaption.defaultProps = {
  subHeader: '',
  subSubHeader: ''
};

export const Image = ({
  src,
  alt,
  size,
  subHeader = '',
  subSubHeader = '',
  sideBySide = false,
  stacked = false,
  ranges = false
}) => {

  const containerClass = 'sui-flex sui-flex-col sui-items-center';
  const textMaxWidth = getTextMaxWidth({ ranges, sideBySide, stacked });

  if (sideBySide || stacked || ranges) {
    return (
      <div className={containerClass}>
        <img
          className="sui-object-contain"
          src={src}
          alt={alt}
          title={alt}
          height={size}
          width={size}
        />
        <ImageCaption
          subHeader={subHeader}
          subSubHeader={subSubHeader}
          className={`sui-w-full ${textMaxWidth} sui-text-left sui-mt-3`}
        />
      </div>
    );
  }

  return (
    <>
      <img
        className="sui-object-contain sui-self-start"
        src={src}
        alt={alt}
        title={alt}
        height={size}
        width={size}
      />

      <ImageCaption subHeader={subHeader} subSubHeader={subSubHeader} className="sui-m-2 !sui-mr-0" />
    </>
  );
};

Image.propTypes = {
  src: string.isRequired,
  alt: string.isRequired,
  size: string.isRequired,
  subHeader: string,
  subSubHeader: string,
  sideBySide: bool,
  stacked: bool,
  ranges: bool
};


